import { useState } from 'react';
import { Link }     from 'react-router-dom';
import SectionHeading from '../components/SectionHeading';
import { SERVICE_SUMMARY } from '../constant/data';

const INITIAL = { name: '', company: '', email: '', phone: '', service: '', message: '' };


const SERVICES = SERVICE_SUMMARY;

function Contact() {
  const [form, setForm]         = useState(INITIAL);
  const [errors, setErrors]     = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading]   = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = 'What should we call you?';
    if (!form.company.trim()) e.company = 'Which organisation are you with?';
    if (!form.email.trim())   e.email   = 'We need an email to get back to you.';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'That doesn\'t look like a valid email.';
    if (!form.phone.trim())   e.phone   = 'A phone number helps us reach you faster.';
    if (!form.message.trim()) e.message = 'Tell us a little about what you need.';
    return e;
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (errors[name]) setErrors(err => ({ ...err, [name]: undefined }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    try {
      const res = await fetch('https://salamahosting.com/contact-api-two.php', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSubmitted(true);
      } else {
        if (data.errors) setErrors(data.errors);
        else setErrors({ message: data.message || 'Something went wrong. Please try again.' });
      }
    } catch {
      setErrors({ message: 'Could not reach the server. Please try again or call us directly.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb-nav">
            <Link to="/">Home</Link>
            <span>/</span>
            Contact
          </div>
          <h1>Get in Touch</h1>
          <p>Drop us a message. We read every enquiry and reply within 24 hours.</p>
        </div>
      </section>

      <section className="section-corporate">
        <div className="container">
          <div className="row g-5">

            {/* Form */}
            <div className="col-lg-7">
              <SectionHeading subtitle="Tell us what you need and we'll come back with an honest answer — no hard sell.">
                Send us a message
              </SectionHeading>

              {submitted ? (
                <div
                  style={{
                    background: 'var(--surface-2)',
                    border: '1px solid var(--border-1)',
                    borderRadius: 'var(--radius)',
                    padding: '2rem',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1rem',
                  }}
                >
                  <i className="fas fa-check-circle" style={{ color: 'var(--ink-1)', fontSize: '1.4rem', marginTop: '0.1rem', flexShrink: 0 }} />
                  <div>
                    <strong style={{ color: 'var(--ink-1)', display: 'block', marginBottom: '0.3rem', fontSize: '1rem' }}>
                      Got it, {form.name.split(' ')[0]}!
                    </strong>
                    <span style={{ color: 'var(--ink-3)', fontSize: '0.9rem' }}>
                      We've received your message. Someone from our team will be in touch within 24 hours.
                    </span>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="form-corporate" noValidate>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">Your Name <span className="text-danger">*</span></label>
                        <input
                          type="text" className={`form-control${errors.name ? ' is-invalid' : ''}`}
                          id="name" name="name" value={form.name} onChange={handleChange}
                          placeholder="e.g. John Mukasa"
                        />
                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="company" className="form-label">Organisation <span className="text-danger">*</span></label>
                        <input
                          type="text" className={`form-control${errors.company ? ' is-invalid' : ''}`}
                          id="company" name="company" value={form.company} onChange={handleChange}
                          placeholder="e.g. ABC Distributors Ltd"
                        />
                        {errors.company && <div className="invalid-feedback">{errors.company}</div>}
                      </div>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                        <input
                          type="email" className={`form-control${errors.email ? ' is-invalid' : ''}`}
                          id="email" name="email" value={form.email} onChange={handleChange}
                          placeholder="you@yourorg.com"
                        />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="phone" className="form-label">Phone <span className="text-danger">*</span></label>
                        <input
                          type="tel" className={`form-control${errors.phone ? ' is-invalid' : ''}`}
                          id="phone" name="phone" value={form.phone} onChange={handleChange}
                          placeholder="+256 700 000 000"
                        />
                        {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="service" className="form-label">What do you need help with?</label>
                    <select className="form-select form-control" id="service" name="service" value={form.service} onChange={handleChange}>
                      <option value="">— Pick one, or skip if unsure —</option>
                      {SERVICES.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="message" className="form-label">Tell us more <span className="text-danger">*</span></label>
                    <textarea
                      className={`form-control${errors.message ? ' is-invalid' : ''}`}
                      id="message" name="message" rows={5} value={form.message} onChange={handleChange}
                      placeholder="What are you dealing with? What would the ideal outcome look like? Even a rough description helps."
                    />
                    {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-gold w-100"
                    disabled={loading}
                    style={{ padding: '0.8rem', fontWeight: 700 }}
                  >
                    {loading
                      ? <><i className="fas fa-spinner fa-spin me-2" />Sending…</>
                      : <><i className="fas fa-paper-plane me-2" />Send Message</>
                    }
                  </button>
                </form>
              )}
            </div>

            {/* Info sidebar */}
            <div className="col-lg-4 offset-lg-1">
              <img
                src="/assets/images/customer_support.png"
                alt="Salama Consult support team"
                style={{
                  width: '100%',
                  height: 220,
                  objectFit: 'cover',
                  borderRadius: 'var(--radius)',
                  marginBottom: '1.25rem',
                  display: 'block',
                  boxShadow: 'var(--shadow)',
                }}
                onError={e => { e.target.style.display = 'none'; }}
              />
              <div className="contact-info-card">
                <h4>Find us here</h4>

                <div className="info-item">
                  <i className="fas fa-map-marker-alt" />
                  <p><strong>Office</strong>Kampala, Uganda</p>
                </div>
                <div className="info-item">
                  <i className="fas fa-phone" />
                  <p>
                    <strong>Phone</strong>
                    +256 702 499 649<br />
                    +256 783 975 685
                  </p>
                </div>
                <div className="info-item">
                  <i className="fas fa-envelope" />
                  <p>
                    <strong>Email</strong>
                    <a href="mailto:info@salamasystems.com" style={{ color: 'rgba(255,255,255,0.7)', display: 'block' }}>info@salamasystems.com</a>
                    <a href="mailto:support@salamasystems.com" style={{ color: 'rgba(255,255,255,0.7)', display: 'block' }}>support@salamasystems.com</a>
                  </p>
                </div>
                <div className="info-item">
                  <i className="fas fa-clock" />
                  <p>
                    <strong>Hours</strong>
                    Mon – Fri: 8 AM – 6 PM<br />
                    Sat: 9 AM – 1 PM
                  </p>
                </div>

                <hr style={{ borderColor: 'rgba(255,255,255,0.12)', margin: '1.25rem 0' }} />

                <div className="response-badge">
                  <i className="fas fa-bolt" />
                  <span>We reply within 24 hours</span>
                </div>

                <div className="mt-4">
                  <a
                    href="https://wa.me/256702499649?text=Hello%20Salama%20Consult%2C%20I%20would%20like%20to%20discuss%20a%20project."
                    className="btn btn-gold w-100"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                  >
                    <i className="fab fa-whatsapp" style={{ fontSize: '1.1rem' }} />
                    Chat on WhatsApp
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
